import React, { useState } from "react";
import "./YoutubeLite.css";

const YoutubeLite = ({ videoId, quality = "max" }) => {
    const [play, setPlay] = useState(false);

    const thumbnail =
        quality === "hq"
            ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
            : `https://i.ytimg.com/vi_webp/${videoId}/maxresdefault.webp`;

    return (
        <div className="youtube-lite">
            {!play ? (
                <button
                    className="youtube-lite__preview"
                    onClick={() => setPlay(true)}
                    aria-label="Reproducir video"
                >
                    <img
                        src={thumbnail}
                        alt="Vista previa del video"
                        className="youtube-lite__thumbnail"
                    />

                    <div className="youtube-lite__play">
                        ▶
                    </div>
                </button>
            ) : (
                <iframe
                    className="youtube-lite__iframe"
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            )}
        </div>
    );
};

export default YoutubeLite;